<template>
    <div v-clickoutside="handleClose">
        <div ref="input" @click="clickSelect" class="mc-btnSelect">
            <slot></slot>
        </div>
        <dropdown
                v-show="visible"
                :style="dropdownXY">
            <ul :class="{
                    'mc-dropdown__scroll': dropdownScroll,
                    'is-ash':ash,
                    'mc-btnSelectBor': true
                  }"  ref="panel">
                <slot name="menuDropdown"></slot>
            </ul>
        </dropdown>
    </div>
</template>
<script type="text/ecmascript-6">
    import Emitter from '../mixins/emitter'
    import {getStyleComputedProperty, getScrollParent} from '../utils/util'
    import dropdown from './base-dropdown'
    export default {
        name: 'mcBtnDropdown',
        mixins: [Emitter],
        components: {
            dropdown
        },
        computed: {
            // 下拉框坐标
            dropdownXY() {
                return {
                    top   : this.rect.bottom + 'px',
                    left  : this.rect.left + 'px',
                    'min-width': '100px',
                }
            }
        },
        props: {
            disabled: {
                type: Boolean,
                description: '禁用',
                default: false
            },
            // 黑色主题
            ash:{
                type: Boolean,
                default: false
            },
        },
        data(){
            return {
                visible: false,
                rect: {
                    bottom  : 0,
                    left    : 0,
                    width   : 0
                },
                dropdownScroll: true
            }
        },
        watch: {
            visible(v){
                this.broadcast('mcBtn', 'onBtnDrop', v)
            }
        },
        methods: {
            // 关闭下拉
            handleClose() {
                this.visible = false;
            },
            resitRect(){
                if(!this.visible){ return; }
                this.$nextTick(()=>{
                    let panelRect = this.$refs.panel.getBoundingClientRect();
                    let windowH = window.innerHeight;
                    let inputRect = this.$refs.input.getBoundingClientRect();

                    // console.log('>>>>>>panelRect', panelRect)

                    if( (windowH - inputRect.bottom) > panelRect.height ) {
                        // console.log('显示在下方')
                        this.rect = inputRect;
                    }else{
                        // console.log('显示在上方 ' );
                        this.rect = {
                            bottom  : inputRect.top - panelRect.height,
                            left    : inputRect.left,
                            width   : inputRect.width
                        }
                    }
                })
            },
            // 点击 input
            clickSelect(e) {
                if(this.disabled){return}
                this.visible = !this.visible;
                this.resitRect();
            },
        },
        directives: {
            clickoutside: {
                bind(el, binding, vnode) {
                    function documentHandler(e) {
                        if (el.contains(e.target)) {  // 判断点击区域是否是指令所在的元素内部
                            return false;               // 是 则跳出函数
                        }

                        if (binding.expression) {     // 判断当前指令（v-clickoutside），是否写了表达式（应为函数
                            binding.value(e);           // 执行指令绑定的函数，即 _handleClose
                        }
                    }
                    function resetRect() {
                        // 修正dropdown坐标
//            vnode.context.rect = el.getBoundingClientRect();
                        vnode.context.resitRect();
                    }

                    el.__vueClickOutside__ = documentHandler;
                    el.__vueScroll__ = resetRect;
                    document.addEventListener('click', documentHandler);
                    document.addEventListener('scroll', el.__vueScroll__);
                    document.addEventListener('resize', el.__vueScroll__);

                },
                inserted(el){
                    let target = getScrollParent( el );
                    target.addEventListener('scroll', el.__vueScroll__);
                },
                unbind(el, binding) {
                    let target = getScrollParent( el );
                    target.removeEventListener('scroll', el.__vueScroll__);
                    document.removeEventListener('click', el.__vueClickOutside__);
                    document.removeEventListener('resize', el.__vueScroll__);
                    document.removeEventListener('scroll', el.__vueScroll__);

                    delete el.__vueClickOutside__;
                    delete el.__vueScroll__;

                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/base-btn-dropdown.vue